/* sp-stone-unavailable v1 — 2026-08-03
 * Dead-stone pages become doorways instead of dead ends. When a diamond page's
 * stone is no longer for sale (sold / on memo / on invoice), the buy controls
 * are replaced with "Find a stone like this" -> the catalog filtered to the
 * same canonical shape + a carat band. Sold pages also get a noindex tag
 * (minted per-stone pages only — NEVER the shared /products/diamonds page).
 *
 * FAIL-SAFE BY DESIGN: acts ONLY on a double-positive signal from the API
 * (is_visible === false AND upstream_status in the dead set). Any error,
 * timeout, or missing field -> the page is left exactly as it was. Live
 * diamonds are structurally unaffected. Additive; delete file to revert.
 */
(function () {
  'use strict';
  if (window.SPJ_DISABLED) return;
  if (window.__SPJ_SU__) return;
  window.__SPJ_SU__ = 1;

  var API = 'https://pxixbvvukwwmhmbyzdfu.supabase.co/functions/v1/storefront-api/diamond/';
  var COLLECT = 'https://zkvdtxlhzucquktwyrjw.supabase.co/functions/v1/collect';
  var AUTH = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InprdmR0eGxoenVjcXVrdHd5cmp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMzcwODMsImV4cCI6MjEwMDkxMzA4M30.T6p6Z4_URBOQHm8kLZXEhVUEf_xAZUk2_t7HpYI1shg';
  var WRITE_KEY = 'sjp_wk_9f27c1e84ab35d60';
  var DEAD = ['Sold', 'On Memo', 'On Invoice', 'Checked Out'];

  var isCanonicalPdp = location.pathname.replace(/\/$/, '') === '/products/diamonds';
  var skuFromQuery = null;
  try { skuFromQuery = new URLSearchParams(location.search).get('sku'); } catch (err) {}

  function track(name, props) {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed() === false) return;
      var m = document.cookie.match(/(?:^|;\s*)_shopify_y=([^;]+)/);
      fetch(COLLECT, {
        method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/json', 'Authorization': AUTH },
        body: JSON.stringify({ k: WRITE_KEY, events: [{ event_id: (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : null, ts: Date.now(), visitor_id: m ? decodeURIComponent(m[1]).slice(0, 64) : null, name: name, source: 'theme', page_type: 'diamond_pdp', page_path: location.pathname + location.search, props: props || {} }] })
      }).catch(function () {});
    } catch (err) {}
  }

  function tfetch(url, ms) {
    var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var o = {};
    if (ctl) { o.signal = ctl.signal; setTimeout(function () { ctl.abort(); }, ms || 8000); }
    return fetch(url, o);
  }

  function similarUrl(stone) {
    var u = '/collections/lab-diamonds';
    // canonical_shape ONLY — raw vendor shapes aren't filter facet values;
    // an unmatched shape param would land on an empty grid (worse dead end)
    var shape = stone.canonical_shape || null;
    var carat = Number(stone.carat);
    var q = [];
    if (shape && /^[A-Za-z ]{3,24}$/.test(shape)) q.push('shape=' + encodeURIComponent(shape));
    if (isFinite(carat) && carat > 0) {
      var lo = Math.max(0.5, Math.round((carat - 0.4) * 10) / 10);
      if (lo > carat) lo = Math.floor(carat * 10) / 10;
      var hi = Math.round((carat + 0.6) * 10) / 10;
      q.push('caratMin=' + lo, 'caratMax=' + hi);
    }
    return q.length ? u + '?' + q.join('&') : u;
  }

  function injectCss() {
    if (document.getElementById('spj-su-css')) return;
    var s = document.createElement('style');
    s.id = 'spj-su-css';
    s.textContent =
      '.spj-su{background:#fff;border:1px solid #e3e6ea;border-radius:8px;padding:18px;margin:12px 0}' +
      '.spj-su__h{font-weight:600;font-size:16px;color:#0A1D2E;margin:0 0 6px}' +
      '.spj-su__p{font-size:13px;color:#5a6572;margin:0 0 12px;line-height:1.5}' +
      '.spj-su__a{display:block;text-align:center;background:#0A1D2E;color:#fff;border-radius:7px;padding:13px 14px;font-size:14px;font-weight:600;text-decoration:none}';
    document.head.appendChild(s);
  }

  function hideEl(el) { if (el) { el.style.setProperty('display', 'none', 'important'); } }

  function swap(stone, anchorSelList) {
    injectCss();
    var anchor = null;
    for (var i = 0; i < anchorSelList.length && !anchor; i++) anchor = document.querySelector(anchorSelList[i]);
    if (!anchor) return false;

    // unique IDs globally; form controls only within the DEAD stone's own form
    // (never collateral-hide quick-add/upsell forms for live products)
    // ship-date promises make no sense for a stone that's gone — hide those too
    ['#addtoring', '#createproduct', '#addToCart',
     '.product-single__meta .ship-timeline-n-tracking',
     '.product-single__meta .ship-msg'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(hideEl);
    });
    var ownForm = anchor.closest ? (anchor.closest('form[action*="/cart/add"]') || (anchor.querySelector ? anchor.querySelector('form[action*="/cart/add"]') : null)) : null;
    if (ownForm) ownForm.querySelectorAll('[type=submit]').forEach(hideEl);

    if (!document.querySelector('.spj-su')) {
      var card = document.createElement('div');
      card.className = 'spj-su';
      card.innerHTML =
        '<p class="spj-su__h">This diamond is no longer available, but we cut stones just like it.</p>' +
        '<a class="spj-su__a" href="' + similarUrl(stone) + '">Find a stone like this →</a>';
      anchor.parentNode.insertBefore(card, anchor);
    }
    return true;
  }

  function swapAndHold(stone, anchors) {
    if (!swap(stone, anchors)) return false;
    // late re-renders can resurrect buttons AND destroy the card — re-run the
    // full (idempotent) swap briefly so both stay correct
    var until = Date.now() + 12000;
    (function hold() {
      swap(stone, anchors);
      if (Date.now() < until) setTimeout(hold, 500);
    })();
    return true;
  }

  function noindex() {
    if (isCanonicalPdp) return; // the shared diamonds page serves live stones — never noindex it
    if (document.querySelector('meta[name="robots"][content*="noindex"]')) return;
    var m = document.createElement('meta');
    m.name = 'robots';
    m.content = 'noindex';
    document.head.appendChild(m);
  }

  function handle(sku, anchors) {
    tfetch(API + encodeURIComponent(sku) + '?type=Ring', 8000)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (d) {
        var s = d && d.Diamond;
        if (!s || typeof s !== 'object' || Array.isArray(s)) return;              // unknown shape: do nothing
        if (s.is_visible !== false) return;                                       // must be POSITIVELY hidden
        if (DEAD.indexOf(String(s.upstream_status)) === -1) return;               // AND positively dead
        var tries = 0;
        (function arm() {
          if (swapAndHold(s, anchors)) {
            window.__SPJ_SU_ACTIVE = 1; // lets sp-arrival-guide stand down
            noindex();
            track('dead_stone_view', { sku: sku, status: s.upstream_status, minted: !isCanonicalPdp });
            return;
          }
          if (++tries < 25) setTimeout(arm, 500); // wait out the page's own hydration
        })();
      })
      .catch(function () {}); // any doubt: leave the page alone
  }

  if (isCanonicalPdp) {
    // the shared live-diamond page must NEVER fall through to the minted branch
    if (skuFromQuery) handle(skuFromQuery.trim(), ['#addtoring', '#createproduct', '#addToCart']);
    return;
  }

  // minted per-stone product pages: /products/<handle>, product type Diamond
  if (location.pathname.indexOf('/products/') === 0) {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      var prod = meta && meta.product;
      if (prod && String(prod.type).trim().toLowerCase() === 'diamond' && prod.variants && prod.variants.length) {
        var sku = String(prod.variants[0].sku || '').trim();
        if (sku) handle(sku, ['form[action*="/cart/add"]', '#addToCart', '.product-form']);
      }
    } catch (err) {}
  }
})();
